module.exports = {
	"articleTitle1": "Ann Arbor students, residents close out bars waiting for election results",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Arbor Brewing Company",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/section/news/arts-ann-arbor-breweries",
	"articleSnippet1": "Nov 9, 2016 ... A viewing party at Ann Arbor Brewing Company was filled to capacity at its start \naround 9 p.m. with about 300 voters at a watch party hosted by ...",
	"articleSnippet2": "Sep 14, 2015 ... Arbor Brewing Company's monthly beer-tasting event had a “Michigan-made” \ntheme that night. Ochre ambiance and a hearty aroma greeted ...",
	"foodRecommendations": [],
	"articleTitle2": "Crafting community: The history of Ann Arbor Breweries ",
	"address": "114 E Washington St, Ann Arbor, MI 48104",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/161109/ahz.ViewingPartyArborBrewing.11.8.16.414.jpg?itok=dUx_Ecxb",
			"author": "Arnold Zhou",
			"caption": "Ann Arbor residents gather to watch the 2016 Presidential Election at Arbor Brewing Company Tuesday."
		}
	],
	"position": {
		"lat": 42.28025,
		"lng": -83.747817
	},
	"totalMisc": 0,
	"categories": {
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/arborbrewingcompany.json
// module id = 813
// module chunks = 0